import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember, TypedJSON} from 'typedjson';

import {IpAddress} from '@/model/network/IpAddress';
import {IpRoute} from '@/model/network/IpRoute';
import {IpMode} from '@/model/network/IpMode';

export abstract class IpStatus {
  @jsonArrayMember(IpAddress, {name: 'addresses'})
  public Addresses!: IpAddress[];

  @jsonMember({name: 'gateway'})
  public Gateway!: string;

  @jsonArrayMember(IpRoute, {name: 'routes'})
  public Routes!: IpRoute[];

  @jsonArrayMember(String, {name: 'domains'})
  public Domains!: string[];

  public mode!: IpMode;

  get HasAddress(): boolean {
    return this.Addresses?.length > 0 ?? false;
  }

  get HasAddresses(): boolean {
    return this.Addresses?.length > 1 ?? false;
  }

  abstract get ValidDns(): string[]

  get HasValidDns(): boolean {
    return this.ValidDns.length > 0;
  }

  get HasValidDnss(): boolean {
    return this.ValidDns.length > 1;
  }

  get ValidRoutes(): IpRoute[] {
    return this.Routes
      .filter((r) => r.Destination !== '' && r.Destination !== '::')
      .sort((a, b) => (b.Metric ?? 10000) - (a.Metric ?? 10000));
  }

  get HasValidRoute(): boolean {
    return this.ValidRoutes.length > 0;
  }
}

@jsonObject
export class Ip4StatusDns {
  @jsonMember({name: 'address'})
  public Address!: string;
}

@jsonObject
export class Ip4Status extends IpStatus {

  @jsonArrayMember(Ip4StatusDns, {name: 'nameServers'})
  public NameServers!: Ip4StatusDns[];

  public constructor() {
    super();
    this.mode = IpMode.IPv4;
  }

  get ValidDns(): string[] {
    return this.NameServers?.filter((dns) => dns.Address !== '')
      .map((dns) => dns.Address) ?? [];
  }
}

@jsonObject
export class Ip6Status extends IpStatus {

  @jsonArrayMember(String, {name: 'nameServers'})
  public NameServers!: string[];

  public constructor() {
    super();
    this.mode = IpMode.IPv6;
  }

  get ValidDns(): string[] {
    return this.NameServers?.filter((dns: string) => dns !== '') ?? [];
  }
}
